import React from "react";
import _find from "lodash/find";
import styles from './priority.module.scss';
import { KoText } from "packages/typography";
import KoIcon from '@kwapio/icons';
import { KoDropdown } from "packages/dropdown";
import { DevelopmentAPI } from "pages/workspace/process/development/development.service";
import { KoToast } from "packages";

function KoPriority(props) {
  const { data, row,refreshData, isEpic } = props;




  const priorityList = [
    { label: "Critical", color: "#de350c", value:5 },
    { label: "High", color: "#e75167", value:4 },
    { label: "Medium", color: "#ff991f", value:3 },
    { label: "Low", color: "#00a3bf", value:2},
    { label: "Lowest", color: "#028759", value:1 }
  ];

  const priority = _find(priorityList, { value: data });


  const updateFields = (obj) => {
    DevelopmentAPI.updateTicketPatch(obj, row?.ticketId || row?.epicId, row?.workspace, isEpic).then(
      (res) => {
        KoToast.success('Priority updated successfully');
        refreshData && refreshData();
      }
    );
  };
  


  const sortTemplates = (key) => {
    updateFields({priority: key});
  };


  const priorityStatus = priorityList.filter(item => item.value !== data);
  const priorityItems = priorityStatus?.map((prty) => ({
    label: (
      <div className={`${styles.filterList}`} onClick={() => sortTemplates(prty.value)}>
        <div className={styles.userDpWithName}>
          <KoIcon
            name="FlagOutlined"
            width={14}
            height={14}
            color={ prty.color}
          />
          {prty?.label}
        </div>
      </div>
    ),
    key: prty?.key,
    value: prty?.value
  }));

  return (
    <div className={styles.priorityWrapper}>
      <KoDropdown
        placement="bottomRight"
        overlayClassName={'overlayClassName'}
        menu={{
          items:priorityItems
        }}
      >
        {data > 0 && priority && (
          <div className={styles.priority}>
            <div className={styles.priorityStatus}>
              <KoIcon
                name="FlagOutlined"
                width={14}
                height={14}
                color={ priority.color}
              />
              <KoText
                text={priority.label}
              
              />
              <KoIcon name="DownArrowOutlined"  height={8} width={8}/>
            </div>
          </div>
        )}
      </KoDropdown>
    </div>
  );
}

export default KoPriority;
